import * as React from 'react'

import classNames from 'classnames/bind'
import _ from 'lodash'

import styles from './index.module.css'

const cx = classNames.bind(styles)
interface ColConfig {
  widthAuto: boolean
}
interface Props {
  multi?: boolean
  columnConfig?: ColConfig[]
  scrollToRow?: boolean
  footer?: boolean
  extra?: Record<string, string | string[] | boolean>
}

const FormRow: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  multi,
  columnConfig,
  scrollToRow,
  footer,
  extra,
}) => {
  const rowRef = React.useRef<HTMLDivElement>(null)

  const scroll = React.useCallback((ref: HTMLDivElement | null) => {
    if (!ref) return

    ref.scrollIntoView({
      behavior: 'smooth',
    })
  }, [])

  React.useEffect(() => {
    if (scrollToRow) {
      scroll(rowRef.current)
    }
  }, [scrollToRow, scroll])

  const renderMultiRow = React.useCallback(
    (element: React.ReactNode, i: number) => {
      if (!React.isValidElement(element)) {
        return null
      }

      const config = columnConfig && columnConfig[i] ? columnConfig[i] : null
      const widthAuto = config ? !!config.widthAuto : false

      return (
        <div
          className={cx('element', {
            widthAuto,
          })}
          key={i}
        >
          {element}
        </div>
      )
    },
    [columnConfig]
  )

  const isRenderMultiRow = !!multi || !!footer

  return (
    <div
      ref={rowRef}
      className={cx('row', {
        multi,
        footer,
      })}
      {...extra}
    >
      {isRenderMultiRow && _.compact(React.Children.toArray(children)).map(renderMultiRow)}
      {!isRenderMultiRow && children}
    </div>
  )
}

export default FormRow
